import { Form, Formik } from "formik";
import React, { useState } from "react";
import * as Yup from "yup";
import cx from "classnames";
import Input from "../../common/components/Forms/Input/Input";
import Button from "../../common/components/Forms/Button/Button";
import useErrorLogger from "../../common/hooks/useErrorLogger";
import { IContactDetails } from "../interfaces/IContactDetails";

const intialValues = {
    name: "",
    email: "",
    phoneNumber: ""
};

const phoneRegExp = /^(?:\+?(?:\(\d+\)|\d+)(?:[\- ]?\d+)*|)$/;

const validationSchema = Yup.object().shape({
    name: Yup.string().required("Please provide your name"),
    email: Yup.string()
        .email("Please enter a valid email")
        .required("Please provide a contact email"),
    phoneNumber: Yup.string()
        .required("Please provide your phone number")
        .matches(phoneRegExp, "Please enter a valid phone number")
});

interface INoRecommendationDetailsFormProps {
    onSubmit: (contact: IContactDetails) => Promise<boolean>;
    className?: string;
}

const NoRecommendationDetailsForm: React.FC<INoRecommendationDetailsFormProps> = (
    props
) => {
    const { className } = props;

    const Log = useErrorLogger();

    const [saved, setSaved] = useState(false);

    const onSubmit = (contact: typeof intialValues): void => {
        props
            .onSubmit({
                email: contact.email,
                name: contact.name,
                mobile: contact.phoneNumber
            })
            .catch((e) => Log.Log(e, { source: "No Recommendation Details Form" }))
            .finally(() => {
                setSaved(true);
            });
    };

    return (
        <Formik
            initialValues={intialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}>
            {({ values, errors, touched, handleChange, handleBlur, isSubmitting }) => (
                <Form
                    className={cx({
                        [className]: !!className
                    })}>
                    <Input
                        name={`name`}
                        label={`Name`}
                        type={`text`}
                        value={values.name}
                        placeholder="Name"
                        className="width-full"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        hasError={touched.name && errors.name}
                    />
                    <Input
                        name={"email"}
                        label={`Email address`}
                        type={`email`}
                        value={values.email}
                        placeholder="Email address"
                        className="width-full"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        hasError={touched.email && errors.email}
                    />

                    <Input
                        id={`phoneNumber`}
                        name={"phoneNumber"}
                        label={`Phone`}
                        type={`tel`}
                        value={values.phoneNumber}
                        placeholder="Mobile"
                        className="gap-2xl width-full"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        hasError={touched.phoneNumber && errors.phoneNumber}
                    />

                    <Button
                        component="button"
                        size="s"
                        width="content"
                        variant="calltoaction"
                        isSubmitting={isSubmitting}
                        isDisabled={isSubmitting || saved}
                        type="submit"
                        dataAttributes={{
                            "data-ga_action": "signin-method",
                            "data-ga_category": "quote-form",
                            "data-ga_label": "manual-submit"
                        }}>
                        {saved ? "Saved" : "Request a callback"}
                    </Button>
                </Form>
            )}
        </Formik>
    );
};

export default NoRecommendationDetailsForm;
